/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cd_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The label switches from “time remaining” to “time since” and counts up, showing how long ago the moment was.`)
};

const es_cd_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La etiqueta cambia de «tiempo restante» a «tiempo transcurrido» y cuenta hacia arriba, mostrando cuánto tiempo hace que ocurrió el momento.`)
};

const de_cd_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Beschriftung wechselt von „verbleibende Zeit“ zu „Zeit seit“ und zählt aufwärts, um anzuzeigen, wie lange der Moment schon zurückliegt.`)
};

const nl_cd_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het label wisselt van 'resterende tijd' naar 'tijd sinds' en telt op, zodat je ziet hoe lang het moment geleden is.`)
};

const fr_cd_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'étiquette passe de « temps restant » à « temps écoulé » et compte en avant, indiquant depuis combien de temps le moment est passé.`)
};

const it_cd_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'etichetta passa da "tempo rimanente" a "tempo trascorso" e conta in avanti, mostrando da quanto tempo è passato quel momento.`)
};

const pt_br2_cd_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O rótulo muda de “tempo restante” para “tempo decorrido” e passa a contar para cima, mostrando há quanto tempo o momento ocorreu.`)
};

const pt_cd_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O rótulo muda de “tempo restante” para “tempo passado” e passa a contar para cima, mostrando há quanto tempo foi o momento.`)
};

const ja_cd_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示ラベルが「残り時間」から「経過時間」に切り替わり、その瞬間からどれくらい経ったかをカウントアップして表示します。`)
};

const zh_cd_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标签会从“剩余时间”切换为“已过去时间”，并开始正向计时，显示该时刻已经过去了多久。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cd_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cd_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cd_faq_a2", locale)
	if (locale === "en") return en_cd_faq_a2(inputs)
	if (locale === "es") return es_cd_faq_a2(inputs)
	if (locale === "de") return de_cd_faq_a2(inputs)
	if (locale === "nl") return nl_cd_faq_a2(inputs)
	if (locale === "fr") return fr_cd_faq_a2(inputs)
	if (locale === "it") return it_cd_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_cd_faq_a2(inputs)
	if (locale === "pt") return pt_cd_faq_a2(inputs)
	if (locale === "ja") return ja_cd_faq_a2(inputs)
	return zh_cd_faq_a2(inputs)
};